import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { NotFound404Component } from '../not-found404/not-found404.component';
import { GetDefaultRouteService } from './get-default-route.service';
import { SAAS_DNS_FILTER, SAAS_URL_FILTER } from '@core/constants/products.constant';
import { PrefetchResolverService } from './prefetch-resolver.service';
import { AuthGuardService } from '../auth/interceptors/auth-guard.service';
import { ProductGuardService } from '../auth/interceptors/product-guard.service';
import { ClientConfigService } from '@core/domains/config/client-config.service';
import { ThemesService } from '@core/domains/destination/theme/themes.service';
import { ThemesStoreService } from '@core/domains/destination/theme/themes.store.service';
import { PaginationStoreService } from '@core/resources/pagination.service';
import { ErrorManagementService } from '@core/tools/error.codes';
import { AppRoutes } from '@core/tools/routes.interface';
import { AdministratorService } from '@core/domains/administrator/administrator.service';
import { provideAppConf } from '../auth/trustlane-login.service';
import { PermissionsGuardService } from '../auth/interceptors/permissions-guard.service';

const routes: AppRoutes = [
  { path: '', component: LayoutComponent, children: [
      // Default module
      { path: '', component: NotFound404Component, canActivate: [GetDefaultRouteService] },
      // DASHBOARD
      { path: 'trust-center', loadChildren: () => import('../trust-center/trust-center.module').then(m => m.TrustCenterModule), data: {
          products: [SAAS_URL_FILTER, SAAS_DNS_FILTER]
        }
      },
      // SECURITY
      { path: 'swg', loadChildren: () => import('../swg/swg.module').then(m => m.SWGModule),  data: {
          products: [SAAS_URL_FILTER, SAAS_DNS_FILTER]
        }
      },
      // CASB
      { path: 'casb', loadChildren: () => import('../casb/casb.module').then(m => m.CasbModule),  data: {
          products: [SAAS_URL_FILTER, SAAS_DNS_FILTER]
        }
      },
      // CONFIGURATION
      { path: 'configuration', loadChildren: () => import('../configuration/configuration.module').then(m => m.ConfigurationModule),
        data: {products: [SAAS_URL_FILTER, SAAS_DNS_FILTER]}
      },
      // TOOLS
      { path: 'tools', loadChildren: () => import('../tools/tools.module').then(m => m.ToolsModule), data: {products: [SAAS_URL_FILTER, SAAS_DNS_FILTER]} },
      // // ADMINISTRATOR
      { path: 'profile', loadChildren: () => import('@core/modules/adminMe/adminMe.module').then(m => m.AdminMeModule), data: {
          products: [SAAS_URL_FILTER, SAAS_DNS_FILTER]
        }
      },
      { path: 'administration', loadChildren: () => import('../administration/administration.module').then(m => m.AdministrationModule), data: {products: [SAAS_URL_FILTER, SAAS_DNS_FILTER]} },


      // SUPPORT
      { path: 'support', loadChildren: () => import('@core/modules/support/support.module').then(m => m.SupportModule) },
      { path: '**', component: NotFound404Component }
    ],
    canActivate: [AuthGuardService],
    canActivateChild: [ProductGuardService],
    resolve: {modules: PrefetchResolverService}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    AuthGuardService,
    GetDefaultRouteService,
    ProductGuardService,
    PaginationStoreService,
    ErrorManagementService,
    ThemesService,
    ThemesStoreService,
    ClientConfigService,
    PrefetchResolverService,
    provideAppConf,
    AdministratorService,
    PermissionsGuardService
  ]
})
export class LayoutRoutingModule { }
